import { Box, Button, Container, ContentLayout, Header, Modal, SpaceBetween, Table } from "@cloudscape-design/components"
import { PageHeader } from "../commons/pageHeader";
import { deletePlayer, getAllPlayers } from "../services/firestore";
import { useNavigate } from "react-router-dom";
import React from "react";

export function AdminPlayers(props: any) {
    const pageConfig = {
        name: "Players",
        url: "/admin-players",
        description: "Hier können Spieler verwaltet werden"
    }
    const [showDeletionModal, setShowDeletionModal] = React.useState(false)
    const [selectedItem, setSelectedItem] = React.useState({
        id: "",
        name: ""
    })
    const navigate = useNavigate()

    return (
        <ContentLayout
            header={<PageHeader app={props.app} page={pageConfig}></PageHeader>}
        >
            <Container
                header={
                    <Header
                        variant="h2"
                        actions={<Button variant="primary" onClick={e => {
                            e.preventDefault()
                            navigate("/create-player")
                        }}
                        >
                            Create Player</Button>}
                    >
                        Overview
                    </Header>
                }>
                <Table
                    columnDefinitions={[
                        {
                            id: "name",
                            header: "Name",
                            cell: item => item.displayName || "-",
                        },
                        {
                            id: "mail",
                            header: "Mail",
                            cell: item => item.email || "-",
                        },
                        {
                            id: "admin",
                            header: "Admin",
                            cell: item => item.admin.toString()
                        },
                        {
                            id: "actions",
                            header: "Actions",
                            cell: item => {
                                return (<Box float="right"><SpaceBetween direction="horizontal" size={"s"}><Button variant="icon" iconName="settings" onClick={e => navigate("/modify-player#" +item.id )} /><Button variant="icon" iconName="remove" onClick={e => {
                                    setSelectedItem({
                                        id: item.id,
                                        name: item.displayName
                                    })
                                    setShowDeletionModal(true)
                                }} /></SpaceBetween></Box>)
                            },
                            width: 110
                        }
                    ]}
                    items={getAllPlayers()}
                    loadingText="Loading resources"
                    sortingDisabled
                    stickyHeader
                    stripedRows
                    variant="embedded"
                    wrapLines
                    empty={
                        <Box
                            margin={{ vertical: "xs" }}
                            textAlign="center"
                            color="inherit"
                        >
                            <SpaceBetween size="m">
                                <b>Bis jetzt wurden keine Spieler angelegt</b>
                            </SpaceBetween>
                        </Box>
                    }
                />
                <Modal
                    visible={showDeletionModal}
                    onDismiss={e => setShowDeletionModal(false)}
                    header={`Delete ${selectedItem.name}?`}
                    footer={
                        <Box float="right">
                            <SpaceBetween direction="horizontal" size="xs">
                                <Button variant="link" onClick={e => setShowDeletionModal(false)}>Cancel</Button>
                                <Button variant="primary" onClick={e => {
                                    deletePlayer(selectedItem.id).then(result => {
                                        setShowDeletionModal(false)
                                    })
                                }}>Yes</Button>
                            </SpaceBetween>
                        </Box>
                    }
                >Möchtest du den Spieler {selectedItem.name} wirklich löschen?</Modal>
            </Container>
        </ContentLayout>
    )
}